export const objects = {
  groupBy: <T>(list: T[], getGroup: (item: T) => string): Record<string, T[]> => {
    const groups: Record<string, T[]> = list.reduce<Record<string, T[]>>((acc, item) => {
      const groupKey = getGroup(item);
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(item);

      return acc;
    }, {});

    return groups;
  },

  copy: <T>(obj: T): T => {
    if (typeof structuredClone !== 'undefined') {
      return structuredClone(obj);
    }
    return JSON.parse(JSON.stringify(obj));
  },

  isObject: (v: unknown) => v !== null && typeof v === 'object',

  deepEqual: (a: unknown, b: unknown): boolean => {
    if (a === b) return true;

    // array comparing
    if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;

      return a.every((item, i) => objects.deepEqual(item, b[i]));
    }

    // plain object comparing
    if (Array.isArray(a) || Array.isArray(b)) {
      return false;
    }

    if (!objects.isObject(a) || !objects.isObject(b)) {
      return false;
    }

    const keysA = Object.keys(a) as Array<keyof typeof a>;
    const keysB = Object.keys(b) as Array<keyof typeof b>;

    if (keysA.length !== keysB.length) return false;

    return keysA.every((key) => key in b && objects.deepEqual(a[key], b[key]));
  },

  isEqual: (a: unknown, b: unknown) => {
    if (objects.isObject(a) && objects.isObject(b)) {
      return objects.deepEqual(a, b);
    }

    return a === b;
  },
};
